import {
  GENRE_OPTIONS,
  DAY_OPTIONS,
  AFFILIATION_OPTIONS,
  HAIR_COLOR_OPTIONS,
  EYE_COLOR_OPTIONS,
  HAIR_LENGTH_OPTIONS,
  ACCESSORY_OPTIONS,
  VOICE_PITCH_OPTIONS,
  VOICE_CHARACTER_OPTIONS,
  GAME_GENRE_OPTIONS,
  TALK_STYLE_OPTIONS,
  PERSONALITY_OPTIONS,
  STREAM_TIME_OPTIONS,
  STREAM_FREQUENCY_OPTIONS,
  LANGUAGE_OPTIONS,
  MODEL_OPTIONS,
  SUBSCRIBER_OPTIONS,
} from "./mockVtubers";

export const FILTER_GROUPS = [
  {
    key: "basic",
    title: "基本情報",
    filters: [
      {
        key: "affiliation",
        label: "個人勢 / 企業勢",
        options: AFFILIATION_OPTIONS,
      },
      { key: "language", label: "メイン言語", options: LANGUAGE_OPTIONS },
      { key: "subscriber", label: "登録者レンジ", options: SUBSCRIBER_OPTIONS },
    ],
  },
  //配信スタイルが難しいので一回閉じておく
  {
    key: "streamStyle",
    title: "配信スタイル",
    filters: [
      {
        key: "streamFrequency",
        label: "配信頻度",
        options: STREAM_FREQUENCY_OPTIONS,
      },
    ],
  },
  {
    key: "appearance",
    title: "見た目",
    filters: [
      { key: "hairColor", label: "髪色", options: HAIR_COLOR_OPTIONS },
      { key: "eyeColor", label: "瞳の色", options: EYE_COLOR_OPTIONS },
      { key: "hairLength", label: "髪の長さ", options: HAIR_LENGTH_OPTIONS },
      { key: "accessory", label: "アクセサリー", options: ACCESSORY_OPTIONS },
    ],
  },
];

export const FILTER_REV = Object.fromEntries(
  FILTER_GROUPS.flatMap((group) =>
    group.filters.flatMap((filter) =>
      filter.options.map((option) => [
        option.value,
        {
          key: filter.key,
          groupKey: group.key,
        },
      ])
    )
  )
);

export function filter_reverse(tag){
  if(tag === "name"){
    return {groupKey:"vtuberName",key:"vtuberName"}
  }
  const splitTag = tag.split(".")
  return {groupKey:splitTag[0],key:splitTag[1]}
}
